import { useState } from "react";

// For a MUI Autocomplete that shows a picked value: opening it clears the
// text so typing starts a fresh search, instead of appending to the picked
// name (which then matched nothing until it was deleted by hand). The picked
// value stays as the placeholder, and comes back as the text if the list
// closes without a new pick.
//
// The clear button (x) works the same way: it empties the text for a new
// search rather than unpicking the value - the dashboard always has one picked.
// Leaving the box without picking puts the picked value's text back.
//
// Spread the result onto the Autocomplete, and pass `placeholder` to its
// TextField. `label` is the picked value's text; `onOpen` runs as well.
export const useSearchOnOpen = (label, onOpen) => {
  const [searching, setSearching] = useState(false);
  const [text, setText] = useState("");

  return {
    inputValue: searching ? text : label,
    onInputChange: (event, value, reason) => {
      // MUI resets the text to the picked value on close and after a pick;
      // only what the user types counts as a search.
      if (reason === "input") setText(value);
      if (reason === "clear") {
        setText("");
        setSearching(true);
      }
    },
    onOpen: (event) => {
      // Already searching (the x was clicked, then typing opened the list):
      // keep what has been typed.
      if (!searching) setText("");
      setSearching(true);
      if (onOpen) onOpen(event);
    },
    onClose: () => setSearching(false),
    onBlur: () => setSearching(false),
    placeholder: label,
  };
};
